import { render } from "./HelloWorld2.vue?vue&type=template&id=3bb02eea&scoped=true"
import script from "./HelloWorld2.vue?vue&type=script&lang=js"
export * from "./HelloWorld2.vue?vue&type=script&lang=js"

import "./HelloWorld2.vue?vue&type=style&index=0&id=3bb02eea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb02eea"]])

export default __exports__